import { render, staticRenderFns } from "./ChooseModule.vue?vue&type=template&id=268cddb1&scoped=true&"
import script from "./ChooseModule.vue?vue&type=script&lang=js&"
export * from "./ChooseModule.vue?vue&type=script&lang=js&"
import style0 from "./ChooseModule.vue?vue&type=style&index=0&id=268cddb1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268cddb1",
  null
  
)

export default component.exports